import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Carousel from "react-multi-carousel";
import {
  GameBanners,
  HomePageGames,
  SetDefaultBannerGames,
  SetDefaultHomePageGames,
  UserTokenCheck,
} from "../../redux/actions";

import ImageLoader from "../../components/imageLoader/ImageLoader";
import GameListCorousal from "../../components/gameListCorousal/GameListCorousal";
import GradeCorousal from "../../components/gameListCorousal/GradeCorousal";

import { gameBannersModify, homepageGamesModify } from "../../utils/Common";
import BannerGameImages from "./BannerGameImages";

import "react-multi-carousel/lib/styles.css";
import "./HomePage.css";

const responsive = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
  tablet: { breakpoint: { max: 1023, min: 464 }, items: 1 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
};

const basicImgData = {
  width: "100vw",
  height: "calc(100vw * 0.28)",
};

function HomePage() {
  const dispatch = useDispatch();

  const [bannerImages, setBannerImages] = useState([]);
  const [homePageGamesList, setHomePageGamesList] = useState([]);

  const {
    gameBannersData,
    homePageGamesData,
    homePageGamesMessage,
    selectedMatType,
  } = useSelector((state) => state.gameStore.gameData);

  const matType = selectedMatType || "ALPHABET";

  // ----------- 1) INITIAL LOAD ---------------
  useEffect(() => {
    if (localStorage.getItem("token")) {
      dispatch(UserTokenCheck());
    }

    // If mat type is not set, set default ALPHABET
    if (!selectedMatType) {
      dispatch({ type: "SET_SELECTED_MAT_TYPE", payload: matType });
    }
  }, []);

  // ----------- 2) ON MAT TYPE CHANGE (MAIN LOGIC) ---------------
  useEffect(() => {
    if (!selectedMatType) return;

    dispatch(SetDefaultBannerGames());
    dispatch(SetDefaultHomePageGames());

    dispatch(GameBanners({ type: "WEB", matType: selectedMatType }));
    dispatch(HomePageGames({ matType: selectedMatType }));

    setHomePageGamesList([]);
  }, [selectedMatType]);

  // ----------- 3) UPDATE BANNERS ---------------
  useEffect(() => {
    setBannerImages(gameBannersModify(gameBannersData));
  }, [gameBannersData]);

  // ----------- 4) UPDATE GAMES LIST ---------------
  useEffect(() => {
    if (!homePageGamesData) return;

    const modified = homePageGamesData.map((gameData) => ({
      ...gameData,
      view: "v",
      data: homepageGamesModify(gameData.data, "v"),
    }));

    setHomePageGamesList(homepageGamesModify(modified));
  }, [homePageGamesData]);

  return (
    <div className="home-page-container">
      {bannerImages.length ? (
        <Carousel
          responsive={responsive}
          showDots={true}
          infinite={true}
          keyBoardControl={true}
          removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
          slidesToSlide={1}
          containerClass="main-corousal-container"
          autoPlay={true}
          autoPlaySpeed={5000}
          transitionDuration={1000}
        >
          {[...bannerImages]
            .sort((a, b) => a.banner_id - b.banner_id)
            .map((img, idx) => (
              <div key={img.banner_id ?? idx}>
                <BannerGameImages img={img} index={idx} />
              </div>
            ))}
        </Carousel>
      ) : (
        <ImageLoader {...basicImgData} />
      )}

      <div className="home-page-data-container">
        {homePageGamesList?.map((data, idx) => (
          <React.Fragment key={idx}>
            {data.catagory !== "Grade" ? (
              <GameListCorousal
                title={data.catagory}
                imagesData={data.data}
                viewtype={data.view}
                gameLevelId={data.gameLevelId}
              />
            ) : (
              <GradeCorousal
                title={data.catagory}
                imagesData={data.data}
                viewtype={data.view}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
